//
import * as yup from 'yup'
import { PoolBaseAccountCTO, PoolBaseAccountCTOSchema } from './PoolBaseAccountCTO'
import { PoolBaseOverviewCTO, PoolBaseOverviewCTOSchema } from './PoolBaseCTO'
import { PoolDynamicAccountCTO, PoolDynamicAccountCTOSchema } from './PoolDynamicAccountCTO'
import { PoolDynamicOverviewCTO, PoolDynamicOverviewCTOSchema } from './PoolDynamicCTO'
import { PoolAccountAccessPairCTOSchema } from './PoolAccountAccessPairCTO'

import { PoolLytAccountCTO, PoolLytAccountCTOSchema } from './PoolLytAccountCTO'
import { PoolLytOverviewCTO, PoolLytOverviewCTOSchema } from './PoolLytOverviewCTO'
import {
  DynamicWithdrawalActivityCTO,
  DynamicWithdrawalActivityCTOSchema,
  PoolEventCTO,
  PoolEventSchema,
  WithdrawalActivityCTO,
  WithdrawalActivityCTOSchema,
} from './PoolEventCTO'
import {
  PoolFlexAccountCTO,
  PoolFlexAccountCTOSchema,
  PoolFlexAccountSummaryCTO,
  PoolFlexAccountSummaryCTOSchema,
} from './PoolFlexAccountCTO'
import { PoolFlexOverviewCTO, PoolFlexOverviewCTOSchema } from './PoolFlexCTO'
import {
  PoolAccountCTO,
  PoolAccountSummaryCTO,
  PoolTermAccountCTOSchema,
  PoolTermAccountSummaryCTOSchema,
} from './PoolTermAccountCTO'
import { poolIsOpenForInvestment, PoolOverviewCTO, PoolOverviewCTOSchema, PoolSummaryDTO } from './PoolTermCTO'

import { ContractCTO, PoolContractCTO } from './ContractCTO'
import { LiquidityAsset } from './LiquidityAsset'
import { PoolOffchainDataReportingSchema } from './PoolOffchainDataCTO'
import { EventNameForTemplate, EventTypeForTemplate, PoolEventEmailStatus } from './templateApx'
import { TemplateDataObject } from './TemplateDataObject'
import { RewardsPlanCTO, RewardsPlanRowCTO } from './RewardsPlanCTO'
import { VaultAccountCTO, VaultAccountCTOSchema } from './VaultAccountCTO'
import {
  PortfolioCTO,
  PortfolioCTOSchema,
  PortfolioPoolCTO,
  PortfolioPoolCTOSchema,
  PortfolioSummaryCTO,
  PortfolioSummaryCTOSchema,
} from './PortfolioCTO'
import { PagingMetadata } from './pagingHelpers'

export {
  PoolAccountAccessPairCTOSchema,
  DynamicWithdrawalActivityCTOSchema,
  PoolBaseAccountCTOSchema,
  PoolBaseOverviewCTOSchema,
  PoolDynamicAccountCTOSchema,
  PoolDynamicOverviewCTOSchema,
  PoolLytAccountCTOSchema,
  PoolLytOverviewCTOSchema,
  PoolEventSchema,
  PoolFlexAccountCTOSchema,
  PoolFlexAccountSummaryCTOSchema,
  PoolFlexOverviewCTOSchema,
  poolIsOpenForInvestment,
  PoolOffchainDataReportingSchema,
  PoolOverviewCTOSchema,
  PoolTermAccountCTOSchema,
  PoolTermAccountSummaryCTOSchema,
  WithdrawalActivityCTOSchema,
  VaultAccountCTOSchema,
  EventTypeForTemplate,
  EventNameForTemplate,
  PoolEventEmailStatus,
  PortfolioSummaryCTOSchema,
  PortfolioPoolCTOSchema,
  PortfolioCTOSchema,
}
export type {
  ContractCTO,
  DynamicWithdrawalActivityCTO,
  LiquidityAsset,
  PoolAccountCTO,
  PoolAccountSummaryCTO,
  PoolBaseAccountCTO,
  PoolBaseOverviewCTO,
  PoolDynamicAccountCTO,
  PoolDynamicOverviewCTO,
  PoolEventCTO,
  PoolFlexAccountCTO,
  PoolFlexAccountSummaryCTO,
  PoolFlexOverviewCTO,
  PoolLytAccountCTO,
  PoolLytOverviewCTO,
  PoolOverviewCTO,
  PoolSummaryDTO,
  RewardsPlanCTO,
  RewardsPlanRowCTO,
  TemplateDataObject,
  WithdrawalActivityCTO,
  VaultAccountCTO,
  PoolContractCTO,
  PortfolioCTO,
  PortfolioPoolCTO,
  PortfolioSummaryCTO,
  PagingMetadata,
}

export const PoolReportingAccountCTOSchema = () => {
  return yup.object({})
}

export const PoolLenderReportingAccountFlexCTOSchema = () => {
  return yup.object({})
}

export const PoolOffchainDataLenderReportingSchema = () => {
  return yup.object({})
}

export const PoolLenderReportingAccountCTOSchema = () => {
  return yup.object({})
}

export const PoolLenderReportingAccountDynamicCTOSchema = () => {
  return yup.object({})
}
